import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

const BeedMeerBanner = (props) => {
    return (
        <Container fluid>
            <Row className="justify-content-center align-items-center">
                <Col onClick={() => { window.location.href = '/'; }}>
                    {/* <div align="center" style={{ fontSize: '3em' }}><b>BeadMeer</b></div>
                    <div align="center" style={{ fontSize: '1em' }}>One-stop Jewellery Pattern Search</div> */}
                    {/* <h2><b>BeadMeer</b></h2> */}
                    <Image alt="BeedMeer" src={process.env.PUBLIC_URL + '/images/BeadMeer-Logo-270.png'} style={{ width: 270 }} fluid />
                </Col>
            </Row>
        </Container>
    )
}

export default BeedMeerBanner;